/**
 * Created by yangHuan on 17/5/31.
 */

import React, { PureComponent, Children, cloneElement } from 'react';
import configShare from '../lib/configShare';
import { queryStringArgs } from '../lib/util';
import { appName } from "../lib/uaInfo";

const { shopId } = queryStringArgs;

const shareBidMapping = {
    'b_rw158iva': '点击分享',
    'b_repyq6sv': '分享成功',
};

export default class PageWrapper extends PureComponent {
    constructor(componentList) {
        super();
        this.componentList = componentList.children;
    }

    componentDidMount() {
        const {
            canShare,
            titleShare,
            desc,
            image,
        } = this.props;

        const shareOption = canShare ? {
            title: titleShare,
            desc,
            image,
            handle: () => {
                const _lx = window.CMPLX || [];
                const bid = 'b_rw158iva';
                _lx.push([bid, shareBidMapping[bid], { adid: 7 }]);
            },
            success: () => {
                const _lx = window.CMPLX || [];
                const bid = 'b_repyq6sv';
                _lx.push([bid, shareBidMapping[bid]]);
            }
        } : {};

        configShare(canShare, shareOption);
    }

    render() {
        const { backgroundColor } = this.props;

        if (backgroundColor) {
            document.body.style.backgroundColor = backgroundColor;
        }

        return (
            <div className="prototype-landing-page-container">
                {
                    Children.map(this.componentList, (child) => {
                        return cloneElement(child, {
                            shopId,
                            appName,
                        });
                    })
                }
            </div>
        )
    }
};





// WEBPACK FOOTER //
// ./src/components/PageWrapper.js